import { Model as ORMModel, attr } from 'redux-orm'
import { Types } from '@fedsim/actions'
import { getId } from '@fedsim/helpers'

export default class Model extends ORMModel {
  static get fields() {
    return {
      id: attr()
    }
  }
  static reducer(action, Injury, session) {
    let item
    switch (action.type) {
      default:
        break
      case Types.RESET:
      case Types.RESET_INJURYS:
        session.Injury.all()
          .toModelArray()
          .forEach(item => item.delete())
        break
      case Types.GENERATE_INJURYS:
        action?.payload?.forEach(newItem => {
          session.Injury.upsert(newItem)
        })
        break
      case Types.ADD_INJURY:
        const id = action?.payload?.id || getId()
        Injury.upsert({ id, ...action.payload })
        break
      case Types.UPDATE_INJURY:
        item = Injury.withId(action.payload.id)
        item.update(action.payload)
        break
      case Types.DELETE_INJURY:
        Injury.withId(action.payload.id).delete()
        break
    }
  }
}
